import { ActionIcon, Tooltip } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { useState } from "react";
import { enrichContactPhoneNumber } from "../../../../api/ContactAPI";
import { notifications } from "@mantine/notifications";
import { enrichProspectPhoneNumber } from "../../../../api/PRMAPI";

const EnrichContactPhoneNumber = ({ row, onFound, apiRef }) => {
  const [loading, setLoading] = useState(false);

  const handleEnrich = () => {
    setLoading(true);

    let func = apiRef ? enrichContactPhoneNumber : enrichProspectPhoneNumber;

    func({
      contact_id: row.id,
      contact_list_id: row.contact_list_id,
    })
      .then((res) => {
        if (res.data.mobile_phone) {
          notifications.show({
            message: "Téléphone Mobile trouvé",
            color: "green",
          });
          if (onFound) {
            return onFound(res.data.mobile_phone);
          } else {
            apiRef.current.updateRows([
              { id: row.id, 7: res.data.mobile_phone },
            ]);
          }
        } else {
          notifications.show({
            message: "Téléphone Mobile non trouvé",
            color: "red",
          });
        }
      })
      // .catch((err) => {
      //   notifications.show({
      //     message: "Téléphone Mobile non trouvé",
      //     color: "red",
      //   });
      // })
      .finally(() => setLoading(false));
  };

  return (
    <Tooltip label="Enrichir le téléphone mobile de ce prospect">
      <ActionIcon
        variant="filled"
        onClick={handleEnrich}
        loading={loading}
        
        ml={apiRef ? "auto" : 8}
        mr={apiRef ? 16 : 0}
        radius={"md"}
      >
        <IconSearch size={apiRef ? 18 : 14} />
      </ActionIcon>
    </Tooltip>
  );
};

export default EnrichContactPhoneNumber;
